import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getCostCenters } from '../../../../../../lib/api/accounting';
import CustomAlert from '../../../../../../lib/designSystem/Alert';
import CenteredCircularProgress from '../../../../../../lib/designSystem/CircularProgress';
import HeaderWithActions, {
  CustomButtonProps,
} from '../../../../../../lib/designSystem/HeaderWithActions';
import EnhancedTable from '../../../../../../lib/designSystem/Table';
import CostCenterDetails from './components/CostCenterDetails';
import NewCostCenter from './components/NewCostCenter';

const headers: { key: string; label: string; type?: any }[] = [
  { key: 'name', label: 'Nombre' },
];

const CostCenters: React.FC = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [costCenters, setCostCenters] = useState<any>([]);
  const [openNewCostCenter, setOpenNewCostCenter] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);
  const [edit, setEdit] = useState(false);
  const [success, setSuccess] = useState('');

  const newCostCenter = {
    id: '',
    name: '',
  };
  const [costCenter, setCostCenter] = useState(newCostCenter);

  const fetchCostCenters = async () => {
    setLoading(true);
    try {
      const response = await getCostCenters(dispatch);
      setCostCenters(response);
    } catch (error) {
      alert('Error al cargar los centros de costo');
    }
    setLoading(false);
  };

  const handleNewCostCenter = () => {
    setEdit(false);
    setCostCenter(newCostCenter);
    setOpenNewCostCenter(true);
  };

  const handleOpenEditModal = () => {
    setEdit(true);
    setOpenDetails(false);
    setOpenNewCostCenter(true);
  };

  const handleDetails = (id: string) => {
    const costCenter = costCenters.find((cc: any) => cc.id === id);
    if (!costCenter) return;
    setCostCenter(costCenter);
    setOpenDetails(true);
  };

  const buttonsData: CustomButtonProps[] = [
    {
      action: () => handleNewCostCenter(),
      name: 'Agregar',
      color: 'primary',
    },
  ];

  useEffect(() => {
    fetchCostCenters();
  }, []);

  if (loading) return <CenteredCircularProgress type="layout" />;

  return (
    <div>
      <HeaderWithActions
        title="Acá encontrarás todos tus centros de costo"
        variant="body1"
        buttons={buttonsData}
      />
      <EnhancedTable
        dataHeaders={headers}
        data={costCenters}
        rowsPerPageDefault={50}
        showActions
        handleClickRow={handleDetails}
      />
      <NewCostCenter
        costCenter={costCenter}
        setCostCenter={setCostCenter}
        open={openNewCostCenter}
        setOpen={setOpenNewCostCenter}
        setSuccess={setSuccess}
        setUp={fetchCostCenters}
        edit={edit}
      />
      <CostCenterDetails
        open={openDetails}
        setOpen={setOpenDetails}
        setUp={fetchCostCenters}
        costCenter={costCenter}
        setCostCenter={setCostCenter}
        handelOpenEditModal={handleOpenEditModal}
        setSuccess={setSuccess}
      />
      <CustomAlert
        open={success.length > 0}
        title={success}
        onClose={() => {
          setSuccess('');
        }}
        setOpen={setSuccess}
        severity="success"
        size="small"
        variant="outlined"
      />
    </div>
  );
};

export default CostCenters;
